export enum DeviceTypeEnum { 
  MagneticCardReader = 0,
  scanner = 1,
  FiscalRegistrar = 2,
  AcquiringTerminal = 3,
  ScaleWithLabelPrinting = 4,
  UserScreen = 5
}

export interface CreateDeviceDto {
  name: string;
  uniqueCode?:string;
  createdDate:Date;
  deviceType?:number;
  driverId?:string;
  userId?:string;
  serialNumber?:string;
}